import React from "react";
import { Box, Typography, Button, LinearProgress } from "@mui/material";

const DiveSubmissionControls = ({
  isUploading,
  uploadProgress,
  isClaimMode,
}) => {
  return (
    <>
      {isUploading && (
        <Box sx={{ mt: 2, mb: 2 }}>
          <Typography variant="body2" gutterBottom>
            Uploading: {uploadProgress}%
          </Typography>
          <LinearProgress
            variant="determinate"
            value={uploadProgress}
            sx={{ height: 10, borderRadius: 1 }}
          />
        </Box>
      )}

      <Button variant="contained" type="submit" disabled={isUploading}>
        {isUploading
          ? "Uploading..."
          : isClaimMode
          ? "Save"
          : "Log Dive"}
      </Button>
    </>
  );
};

export default DiveSubmissionControls;
